import { apiCall } from './generated/gqlClient';

const getAllPersonnelApiRequest = async (providerId, archivedAsWell) => {
  const query = `
    query getResources($providerId: Int, $archivedAsWell: Boolean) {
      getResources(providerId: $providerId, archivedAsWell: $archivedAsWell) {
        id
        userId
        name
        gender
        resTypeId
        archive
        user {
          id
          fullname
          firstname
          lastname
          gender
          birthday
          address
          city
          postcode
          country
          tags
          url
          facebook
          phone
          email
          role
          image
        }
      }
    }
  `;
  return apiCall({ query, variables: { providerId: +providerId, archivedAsWell } });
};

const getAllArchivedResourcesApiRequest = async () => {
  const query = `
    query getAllArchivedResources {
      getAllArchivedResources {
        id
        userId
        name
        gender
        resTypeId
        user {
          id
          fullname
          firstname
          lastname
          gender
          birthday
          address
          city
          postcode
          country
          tags
          url
          facebook
          phone
          email
          role
        }
      }
    }
  `;
  return apiCall({ query });
};

const getAllPhysicalPersonnelApiReqeust = async providerId => {
  const query = `
    query getPhysicalResources($providerId: Int) {
      getPhysicalResources(providerId: $providerId) {
        id
        name
        resTypeId
        quantity
        capacity
      }
    }
  `;
  return apiCall({ query, variables: { providerId: +providerId } });
};

const getCollaboratorsApiRequest = async () => {
  const query = `
    query getCollaborators {
      getCollaborators {
        id
        resourceId
        name
        fullname
        gender
        role
      }
    }
  `;

  return apiCall({ query });
};

const getResourceScheduleApiRequest = async resourceId => {
  const query = `
    query getSchedule($resourceId: Int) {
      getSchedule(resourceId: $resourceId) {
        day
        workTime {
          startTime
          endTime
        }
        break {
          startTime
          endTime
        }
      }
    }
  `;

  return apiCall({ query, variables: { resourceId: +resourceId } });
};

const getProviderScheduleApiRequest = async () => {
  const query = `
    query getSchedule {
      getSchedule {
        day
        workTime {
          startTime
          endTime
        }
        break {
          startTime
          endTime
        }
      }
    }
  `;
  return apiCall({ query });
};

const saveResourceScheduleApiRequest = async (resourceId, schedules) => {
  const mutation = `
    mutation saveSchedule($schedules: [ScheduleInputItem]!, $resourceId: Int) {
      saveSchedule(schedules: $schedules, resourceId: $resourceId) {
        success
        message
      }
    }
  `;
  return apiCall({ query: mutation, variables: { resourceId, schedules } });
};

const createResourceApiRequest = async request => {
  const mutation = `
    mutation createResource($request: ResourceCreateInput) {
      createResource(request: $request) {
        id
        success
        message
      }
    }
  `;
  return apiCall({ query: mutation, variables: { request } });
};

const getSubservicesClassesByResourceApiRequest = async resourceId => {
  const query = `
    query getSubservicesClassesByResource($resourceId: Int!) {
      getSubservicesClassesByResource(resourceId: $resourceId) {
        subservices {
          id
          name
        }
        classes {
          id
          name
        }
      }
    }
  `;

  return apiCall({ query, variables: { resourceId } });
};

const getIndividualCollaboratorPercentApiRequest = async resourceId => {
  const query = `
    query getIndividualCollaboratorPercent($resourceId: Int!) {
      getIndividualCollaboratorPercent(resourceId: $resourceId) {
        subservices {
          id
          resourceId
          amountType
          amount
          subserviceId
          subserviceName
        }
        classes {
          id
          resourceId
          amountType
          amount
          classId
          className
        }
      }
    }
  `;

  return apiCall({ query, variables: { resourceId } });
};

export {
  createResourceApiRequest,
  getAllArchivedResourcesApiRequest,
  getAllPersonnelApiRequest,
  getAllPhysicalPersonnelApiReqeust,
  getCollaboratorsApiRequest,
  getIndividualCollaboratorPercentApiRequest,
  getProviderScheduleApiRequest,
  getResourceScheduleApiRequest,
  getSubservicesClassesByResourceApiRequest,
  saveResourceScheduleApiRequest,
};
